import { Navigate, Route, Routes } from "react-router-dom";
import Layout from './components/Layout';
import Product from "./pages/Product";
import Applications from "./pages/Applications";
import { ClientProvider } from "./context/ClientProvider";
import LoadingComponent from './components/LoadingComponent';
import LanguageProvider from "./context/LanguageProvider";
import { APP_ROUTES } from "./hooks/useAppNavigation";
import Redirect from "./pages/Redirect";
import ErrorPage from "./pages/ErrorPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import { loginRequest } from "./authConfig";
import { LayoutLanguageProvider } from "./context/LayoutLanguageContext";
import { ProductLanguageProvider } from './context/ProductLanguageContext';
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import {SimulationProvider} from "./context/SimulationContext";


const ProtectedAppContent = () => {
    return (
        <ProductLanguageProvider>
            <LayoutLanguageProvider>
                <SimulationProvider>
                    <Layout>
                    <Routes>
                        <Route path="/" element={<Navigate to={APP_ROUTES.APP} replace />} />
                        <Route
                            path={APP_ROUTES.PRODUCT}
                            element={
                                <LoadingComponent>
                                    <ClientProvider>
                                        <LanguageProvider>
                                            <Product />
                                        </LanguageProvider>
                                    </ClientProvider>
                                </LoadingComponent>
                            }
                        />
                        <Route path={APP_ROUTES.APP} element={<Applications />} />
                        <Route path={APP_ROUTES.UNAUTHORIZED} element={<UnauthorizedPage />} />
                        <Route path="*" element={<Navigate to={APP_ROUTES.APP} replace />} />
                        <Route path={APP_ROUTES.ERROR} element={<ErrorPage />} /></Routes>
                </Layout>
                </SimulationProvider>
            </LayoutLanguageProvider>
        </ProductLanguageProvider>
    );
};

const MainApp = () => {
    return (
        
        <LayoutLanguageProvider>           

        <Routes>

            {/* Public route: /redirect and /error */}

            
            <Route path={APP_ROUTES.REDIRECT} element={<Redirect />} />

            {/* Protected part: everything else triggers B2C login if not authenticated */}
            <Route
                path="/*"
                element={
                   
                    <MsalAuthenticationTemplate
                        interactionType={InteractionType.Redirect}
                        authenticationRequest={loginRequest}
                        errorComponent={({ error }) => <ErrorPage error={error} />}
                    >

                        <ProtectedAppContent />
                    </MsalAuthenticationTemplate>
                }
            />
        </Routes>
            </LayoutLanguageProvider>
    );
};

export default MainApp;
